export default {"src":"/_next/static/media/handshake.f0dce605.svg","height":48,"width":54,"blurWidth":0,"blurHeight":0};